export default {
    backToTop() {
        this.showScrollTop = false
        this.$vuetify.goTo(0)
    },

    checkBackToTop() {
        clearTimeout(this.scrollTopTimer)

        this.scrollTopTimer = setTimeout(() => {
            this.processCheckBackToTop()
        }, 50)
    },

    processCheckBackToTop() {
        let scroll = window.scrollY
        if (scroll > 400) {
            this.showScrollTop = true
        } else {
            this.showScrollTop = false
        }
    }
}